import React from 'react';

const EffectPill = ({ value }) => {
  const getPillConfig = (value) => {
    switch (value) {
      case 1:
        return {
          text: 'Augmente',
          color: '#0AD69F'
        };
      case -1:
        return {
          text: 'Diminue', 
          color: '#EF456E'
        };
      case 0:
      default:
        return {
          text: 'Aucun effet',
          color: '#9CA3AF'
        };
    }
  };

  const config = getPillConfig(value);

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '4px 12px',
        borderRadius: '30px',
        fontSize: '12px',
        fontWeight: 600,
        fontFamily: 'Montserrat, sans-serif',
        textTransform: 'none',
        letterSpacing: '0px',
        opacity: 1,
        backgroundColor: config.color,
        color: 'white',
        border: `1px solid ${config.color}`,
      }}
    >
      {config.text}
    </span>
  );
};

export default EffectPill;
